import React from 'react';

import { SpinnerProps } from './spinner.types';
import { CircleContainer, StarContainer, Orbit } from './spinner.styles';

export const Spinner: React.FC<SpinnerProps> = ({ type, useThemeColor, size }) => {
  switch (type) {
    case 'circle':
      return (
        <CircleContainer size={size} useThemeColor={useThemeColor}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </CircleContainer>
      );
    case 'orbit':
      return <Orbit size={size} useThemeColor={useThemeColor} />;
    default:
      return (
        <StarContainer size={size}>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
        </StarContainer>
      );
  }
};
